import React, {useState, useEffect} from 'react';
import {Button, Dialog, DialogContent, TextField, DialogActions, Grid, useMediaQuery,Theme} from "@mui/material";
import {agregarEditarGasto} from "../../redux/reducers/gastoReducers";

import SelectCaja from "../../components/selects/SelectCaja";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import {SlideTransition} from "../../components/transitions";
import {useNavigate, useLocation} from "react-router-dom";
import {formatDate, moment, nullToEmptyString} from "../../helpers";
import {MostrarError} from "../../components/MostrarError";
import LoadingProgress from "../../components/LoadingProgress";
import {DateInput, TextFieldCurrency} from "../../components/CustomTextField";
import SelectUsoMultiples from "../../components/selects/SelectUsoMultiples";
import Strings from "../../assets/strings"
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IGasto} from "../../redux/types/IGasto";
const TranLeft = SlideTransition("left");

let initialState:IGasto={
    fecha: moment(new Date()).format("YYYY-MM-DD"),
    categoriaId: undefined,
    concepto: "",
    monto: 0,
    cajaId: undefined,
    comentario: "",

};
function Crear() {
    const defaultCajId = useAppSelector(state=>state?.auth?.user?.cajaIdDefault );
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const goBack = ()=>navigate(-1);
    const {state:urlState} = useLocation();
    const { status, error } = useAppSelector(state=>state.gastos);

    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    const [state, setState] = useState(initialState);


    useEffect(() => {
        if(urlState)
            setState(state=>({...state,...nullToEmptyString(urlState)}));
        else
            setState({...initialState,cajaId:defaultCajId});
    }, [setState, urlState,defaultCajId]);

    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setState({...state,[name]:value})
    };
    const handleSubmit = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(agregarEditarGasto(state))
    };


    return (
        <>
            <Dialog open={Boolean(urlState && urlState.hasOwnProperty("id"))} onClose={goBack}
                    fullScreen={smVewport} maxWidth={"xs"}
                    {...(smVewport ? {TransitionComponent: TranLeft}:{})}
            >


                <TopBarDialog title={"Agregar gasto"} onClose={goBack}>
                </TopBarDialog>
                    <DialogContent>
                        <MostrarError errors={error}/>
                        {(status==="loading") && <LoadingProgress/>}
                        <br/>
                        <form id="form1" onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    {/*// @ts-ignore*/}
                                    <DateInput
                                        name="fecha"
                                        value={state.fecha || formatDate(new Date(),"YYYY-MM-DD")}
                                        onChange={handleChange}
                                        required
                                        label={Strings.fecha}
                                        InputProps={{readOnly: !!state.id}}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <SelectUsoMultiples
                                        // emptyOption={{key:"",value:Strings.ninguna}}
                                        group="1"
                                        name="categoriaId"
                                        value={state.categoriaId}
                                        onChange={handleChange}
                                        label={Strings.categoria}
                                        disabled={!!state.id}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="concepto"
                                        value={state.concepto}
                                        onChange={handleChange}
                                        required
                                        label={Strings.concepto}
                                        fullWidth
                                        inputProps={{maxLength: 100}}
                                        InputProps={{readOnly: !!state.id}}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextFieldCurrency
                                        name="monto"
                                        value={state.monto}
                                        onChange={handleChange}
                                        required
                                        label={Strings.monto}
                                        fullWidth
                                        InputProps={{readOnly: !!state.id}}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    {/*// @ts-ignore*/}
                                    <SelectCaja
                                        name="cajaId"
                                        value={state.cajaId}
                                        onChange={handleChange}
                                        // InputProps={{readOnly: !!state.id}}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="comentario"
                                        value={state.comentario}
                                        onChange={handleChange}
                                        label={Strings.comentario}
                                        rows={2}
                                        fullWidth
                                        multiline
                                        inputProps={{maxLength: 150}}
                                        InputProps={{readOnly: !!state.id}}
                                    />
                                </Grid>
                            </Grid>
                        </form>
                        <br/>
                    </DialogContent>
                    {!state.id &&
                        <DialogActions>
                            <Button type={"button"} color="warning" variant={"text"} onClick={goBack}>
                                {Strings.cancelar}
                            </Button>
                            <Button
                                type="submit"
                                form={"form1"}
                                color="primary"
                                disabled={status === "loading"}
                                variant={"outlined"}
                            >
                                {!!state.id ? Strings.actualizar : Strings.agregar}
                            </Button>
                        </DialogActions>
                    }
            </Dialog>

        </>
    );

}

export default Crear;
